const GENDERS = [
  {
    value: 'f',
    label: '女性'
  },
  {
    value: 'm',
    label: '男性'
  },
  {
    value: 'u',
    label: '未設定'
  }
]

const GENDERS_SELECT = [
  {
    value: 'u',
    label: '性別を選択してください'
  },
  {
    value: 'f',
    label: '女性'
  },
  {
    value: 'm',
    label: '男性'
  }
]

const BIRTH_YEAR_SUB_START = 120
const BIRTH_YEAR_SUB_END = 20

const BLOOD_TYPE = [
  {
    value: 'A',
    label: 'A型'
  },
  {
    value: 'B',
    label: 'B型'
  },
  {
    value: 'O',
    label: 'O型'
  },
  {
    value: 'AB',
    label: 'AB型'
  },
  {
    value: 'UK',
    label: '不明'
  }
]

const BLOOD_TYPE_SELECT = [
  {
    value: '',
    label: '血液型を選択してください'
  },
  {
    value: 'A',
    label: 'A型'
  },
  {
    value: 'B',
    label: 'B型'
  },
  {
    value: 'O',
    label: 'O型'
  },
  {
    value: 'AB',
    label: 'AB型'
  },
  {
    value: 'UK',
    label: '不明'
  }
]

const GENRE_WORRY = [
  {
    value: 1,
    imageValue: 1,
    label: '恋愛・片思い'
  },
  {
    value: 2,
    imageValue: 2,
    label: '結婚'
  },
  {
    value: 3,
    imageValue: 3,
    label: '欲望・性'
  },
  {
    value: 4,
    imageValue: 4,
    label: 'お金・財産'
  },
  {
    value: 5,
    imageValue: 5,
    label: '仕事・経営'
  },
  {
    value: 6,
    imageValue: 6,
    label: '対人・良縁'
  },
  {
    value: 7,
    imageValue: 7,
    label: '健康・病気'
  },
  {
    value: 8,
    imageValue: 8,
    label: '家庭・子供'
  },
  {
    value: 9,
    imageValue: 9,
    label: '総合'
  }
]

const GENRE_GENRE = [
  {
    value: 10,
    imageValue: 1,
    label: 'スピリチュアル'
  },
  {
    value: 11,
    imageValue: 2,
    label: '風水'
  },
  {
    value: 12,
    imageValue: 3,
    label: '姓名判断'
  },
  {
    value: 13,
    imageValue: 4,
    label: 'タロット'
  },
  {
    value: 14,
    imageValue: 5,
    label: '手相'
  },
  {
    value: 15,
    imageValue: 6,
    label: 'その他'
  }
]

const HOROSCOPES = [
  {
    value: 120,
    label: '山羊座',
    image: '/assets/img/horoscope/12_capricorn.png'
  },
  {
    value: 218,
    label: '水瓶座',
    image: '/assets/img/horoscope/12_aquarius.png'
  },
  {
    value: 320,
    label: '魚座',
    image: '/assets/img/horoscope/12_pisces.png'
  },
  {
    value: 420,
    label: '牡羊座',
    image: '/assets/img/horoscope/12_aries.png'
  },
  {
    value: 520,
    label: '牡牛座',
    image: '/assets/img/horoscope/12_taurus.png'
  },
  {
    value: 621,
    label: '双子座',
    image: '/assets/img/horoscope/12_gemini.png'
  },
  {
    value: 722,
    label: '蟹座',
    image: '/assets/img/horoscope/12_cancer.png'
  },
  {
    value: 822,
    label: '獅子座',
    image: '/assets/img/horoscope/12_leo.png'
  },
  {
    value: 922,
    label: '乙女座',
    image: '/assets/img/horoscope/12_virgo.png'
  },
  {
    value: 1023,
    label: '天秤座',
    image: '/assets/img/horoscope/12_libra.png'
  },
  {
    value: 1122,
    label: '蠍座',
    image: '/assets/img/horoscope/12_scorpio.png'
  },
  {
    value: 1221,
    label: '射手座',
    image: '/assets/img/horoscope/12_sagittarius.png'
  }
]

const PAGE_FIXED_IDS = [
  {
    value: 1,
    code: 'top_page_top',
    label: 'トップページ(上部)'
  },
  {
    value: 2,
    code: 'latest_deals',
    label: '最新お得情報'
  },
  {
    value: 3,
    code: 'how_to_use',
    label: 'ご利用方法'
  },
  {
    value: 4,
    code: 'about_points',
    label: 'ポイントについて'
  },
  {
    value: 5,
    code: 'faq',
    label: 'よくある質問'
  },
  {
    value: 6,
    code: 'terms_of_service',
    label: '利用規約'
  },
  {
    value: 7,
    code: 'company_profile',
    label: '会社概要'
  },
  {
    value: 8,
    code: 'specified_commercial_transactions',
    label: '特定商取引法に基づく表記'
  },
  {
    value: 9,
    code: 'privacy_policy',
    label: 'プライバシーポリシー'
  },
  {
    value: 10,
    code: 'contact_us',
    label: 'お問い合わせ'
  },
  {
    value: 11,
    code: 'withdrawal',
    label: '退会申請'
  }
]

const BITCASH_STORE_EXPLANATION = [
  {
    value: 'seven',
    title: 'セブンイレブンでの購入',
    steps: [
      { explanation: 'セブンイレブン店頭にあるマルチコピー機から購入申し込みをおこないます。', image: '/assets/img/point/bitcash/seven/step1.gif' },
      { explanation: 'マルチコピー機トップ画面の「プリペイドサービス」を選択してください。', image: '/assets/img/point/bitcash/seven/step2.gif' },
      { explanation: 'プリペイドサービス内の「ビットキャッシュ」を選択してください。', image: '/assets/img/point/bitcash/seven/step3.gif' },
      { explanation: '次に「ビットキャッシュ」をお選びください。', image: '/assets/img/point/bitcash/seven/step4.gif' },
      { explanation: '確認画面が表示されます。商品の内容を確認し、よろしければ「OK」ボタンを押してください。', image: '/assets/img/point/bitcash/seven/step5.gif' },
      { explanation: '同意確認画面が表示されます。内容を確認し、よければ「同意する」ボタンを押してください。', image: '/assets/img/point/bitcash/seven/step6.gif' },
      { explanation: 'ご希望の券種を選択してください。', image: '/assets/img/point/bitcash/seven/step7.gif' },
      { explanation: '「増やす」「減らす」ボタンで枚数を指定し、よろしければ「OK」ボタンを押してください。', image: '/assets/img/point/bitcash/seven/step8.gif' },
      { explanation: '申込内容が表示されます。内容を確認し、「OK」ボタンを押してください。', image: '' },
      { explanation: '手続きを完了すると、マルチコピー機より[プリペイドサービス代金払込票]が出力されます。出力された[プリペイドサービス代金払込票]を持ってレジにて代金をお支払いください。', image: '/assets/img/point/bitcash/seven/step10.gif' },
      { explanation: 'お支払い後、レジにて「プリペイドチケット」（ビットキャッシュシート）をお渡しします。ここにひらがなIDが記載されています。', image: '/assets/img/point/bitcash/seven/step11.gif' }
    ]
  },
  {
    value: 'lawson',
    title: 'ローソンでの購入',
    steps: [
      { explanation: 'ローソン店舗にある「Loppi」で購入申し込みを行ってください。Loppiトップ画面の「各種サービスメニュー」を選択してください。', image: '/assets/img/point/bitcash/lawson/step1.gif' },
      { explanation: '下から2番目の「携帯・国際プリペイド（Prepaid international） ／ ネット用マネー ／ QUO ／ 各種申込（学び・保険等）」を選択してください。', image: '/assets/img/point/bitcash/lawson/step2.gif' },
      { explanation: '「ネット用マネー」を選択してください。', image: '/assets/img/point/bitcash/lawson/step3.gif' },
      { explanation: '「ビットキャッシュ」を選択してください。', image: '/assets/img/point/bitcash/lawson/step4.gif' },
      { explanation: 'サービス内容をご確認ください。「○はい」を押して次へ進みます。', image: '/assets/img/point/bitcash/lawson/step5.gif' },
      { explanation: 'ご希望の金額を選択してください。', image: '/assets/img/point/bitcash/lawson/step6.gif' },
      { explanation: '選択した券種と金額をご確認ください。「○はい」を押して次へ進みます。', image: '/assets/img/point/bitcash/lawson/step7.gif' },
      { explanation: '「申込券」がLoppiから出力されます。その「申込券」をお持ちになって、レジにて代金をお支払いください。※出力から支払いをしないまま30分経過すると自動的にキャンセルとなります。代金のお支払いは「現金のみ」となります。', image: '/assets/img/point/bitcash/lawson/step8.gif' },
      { explanation: 'お支払い後、レジにて領収書(ビットキャッシュシート)をお渡しします。ここにひらがなIDが記載されています。', image: '/assets/img/point/bitcash/lawson/step9.gif' }
    ]
  },
  {
    value: 'familymart',
    title: 'ファミリーマートでの購入',
    steps: [
      { explanation: 'まず、ファミリーマート店頭にあるFamiポートで購入申し込みをしていただきます。Famiポートトップ画面の「プリペイド」を選択してください。', image: '/assets/img/point/bitcash/familymart/step1.gif' },
      { explanation: '次に、「電子マネー(オンラインマネー)」を選択してください。', image: '/assets/img/point/bitcash/familymart/step2.gif' },
      { explanation: '電子マネー(オンラインマネー)のジャンルから「ビットキャッシュ」を選択してください。', image: '/assets/img/point/bitcash/familymart/step3.gif' },
      { explanation: '再度確認し、よろしければ「OK」を選択してください。※買い間違いによる返金は一切行いませんので予めご了承ください。', image: '/assets/img/point/bitcash/familymart/step4.gif' },
      { explanation: 'ご希望の金額を選択してください。', image: '/assets/img/point/bitcash/familymart/step5.gif' },
      { explanation: '確認画面が表示されますので、内容をご確認頂いた後、「発行する」を選択してください。', image: '/assets/img/point/bitcash/familymart/step6.gif' },
      { explanation: 'Famiポート端末より「Famiポート申込券」が出力されます。その「Famiポート申込券」を持ってレジにて代金をお支払い下さい。代金のお支払いは「現金のみ」となります。', image: '/assets/img/point/bitcash/familymart/step7.gif' },
      { explanation: 'お支払い後、レジにて「プリペイド番号通知票」をお渡しします。ここにひらがなIDが記載されています。', image: '/assets/img/point/bitcash/familymart/step8.gif' }
    ]
  },
  {
    value: 'ministop',
    title: 'ミニストップでの購入',
    steps: [
      { explanation: 'ミニストップ店舗にある「MINISTOP Loppi」で購入申し込みを行ってください。Loppiトップ画面の「各種サービスメニュー」を選択してください。※一部取り扱いのない店舗もございます。その場合は店員にお尋ねください。', image: '/assets/img/point/bitcash/ministop/step1.gif' },
      { explanation: '下から2番目の「携帯・国際プリペイド（Prepaid international） ／ ネット用マネー ／ QUO ／ 各種申込（学び・保険等）」を選択してください。', image: '/assets/img/point/bitcash/ministop/step2.gif' },
      { explanation: '「ネット用マネー」を選択してください。', image: '/assets/img/point/bitcash/ministop/step3.gif' },
      { explanation: '「ビットキャッシュ」を選択してください。', image: '/assets/img/point/bitcash/ministop/step4.gif' },
      { explanation: 'サービス内容をご確認ください。「○はい」を押して次へ進みます。', image: '/assets/img/point/bitcash/ministop/step5.gif' },
      { explanation: 'ご希望の金額を選択してください。', image: '/assets/img/point/bitcash/ministop/step6.gif' },
      { explanation: '選択した券種と金額をご確認ください。「○ OK」を押して次へ進みます。', image: '/assets/img/point/bitcash/ministop/step7.gif' },
      { explanation: 'お支払い時の注意事項をご確認ください。「○ OK」を押して次へ進みます。', image: '/assets/img/point/bitcash/ministop/step8.gif' },
      { explanation: '「申込券」がMINISTOP Loppiから出力されます。その「申込券」をお持ちになって、レジにて代金をお支払いください。※出力から支払いをしないまま30分経過すると自動的にキャンセルとなります。代金のお支払いは「現金のみ」となります。', image: '/assets/img/point/bitcash/ministop/step9.gif' },
      { explanation: 'お支払い後、レジにてプリペイドサービス番号お知らせシートをお渡しします。ここにひらがなIDが記載されています。', image: '/assets/img/point/bitcash/ministop/step10.gif' }
    ]
  },
  {
    value: 'others',
    title: 'その他のコンビニでの購入',
    steps: [
      { explanation: '店頭のカードモールからご希望のビットキャッシュカードを取りレジカウンターへお持ちください。', image: '/assets/img/point/bitcash/others/step1.gif' },
      { explanation: 'ビットキャッシュカードを店員に渡し、代金をお支払いください。金額指定の場合には1,500～50,000クレジットの間でご希望の金額をお伝えください。※お問い合わせ時に必要となりますので、レシートは必ずお受け取りになり、使い終わるまで保管してください。', image: '' },
      { explanation: 'ビットキャッシュカード裏面のミシン目部分をめくってください。ひらがなIDが記載されていますのでご利用ください。', image: '/assets/img/point/bitcash/others/step3.gif' }
    ]
  },
  {
    value: 'drugstore',
    title: '全国のドラッグストア等での購入',
    steps: [
      { explanation: '店頭のカードモールからご希望のビットキャッシュカードを取りレジカウンターへお持ちください。', image: '/assets/img/point/bitcash/drugstore/step1.gif' },
      { explanation: 'ビットキャッシュカードを店員に渡し、代金をお支払いください。金額指定の場合には1,500～50,000クレジットの間でご希望の金額をお伝えください。※お問い合わせ時に必要となりますので、レシートは必ずお受け取りになり、使い終わるまで保管してください。', image: '' },
      { explanation: 'ビットキャッシュカード裏面のミシン目部分をめくってください。ひらがなIDが記載されていますのでご利用ください。', image: '/assets/img/point/bitcash/drugstore/step3.gif' }
    ]
  }
]

const SECURITMONEY_FORM_EXPLANATION = [
  {
    steps: [
      { explanation: '①お近くのファミリーマートにて【コピー機】を店内でお探しください。', image: '/assets/img/point/securitymoney/sm_step1.jpg' },
      { explanation: '②ファミポートの画面にて【プリペイドの購入】を選択してください。', image: '/assets/img/point/securitymoney/sm_step2.jpg' },
      { explanation: '③【セキュリティーマネー】を選択してください。', image: '/assets/img/point/securitymoney/sm_step3.png' },
      { explanation: '④【OK】を押してください。', image: '/assets/img/point/securitymoney/sm_step4.jpg' },
      { explanation: '⑤【ご希望の金額】を選択してください。', image: '/assets/img/point/securitymoney/sm_step5.jpg' },
      { explanation: '⑥金額を確認し【OK】を押してください。', image: '/assets/img/point/securitymoney/sm_step6.jpg' },
      { explanation: '⑦申込券が発券されますので、レジにお持ちになり、お支払いを済ませてください。', image: '/assets/img/point/securitymoney/sm_step7.png' },
      { explanation: '⑧お支払い完了後、下記用紙を受け取ってください。', image: '/assets/img/point/securitymoney/sm_step8.jpg' },
      { explanation: '⑨本ページ下部より、ご購入頂いた金額を選択し、用紙に記載されているプリペイド番号をご入力ください。', image: '' }
    ]
  }
]

const GMONEY_FORM_EXPLANATION = [
  {
    steps: [
      { explanation: '①店内のマルチコピー機の左側タッチパネルでTOPメニューを開きます。', image: '/assets/img/point/gmoney/sm_step1.jpg' },
      { explanation: '②「プリペイドの購入」のボタンをタッチします。', image: '/assets/img/point/gmoney/sm_step2.jpg' },
      { explanation: '③「オンラインマネー（電子マネー）」のボタンをタッチします。', image: '/assets/img/point/gmoney/sm_step3.png' },
      { explanation: '④「G-MONEY」のボタンをタッチします。', image: '/assets/img/point/gmoney/sm_step4.png' },
      { explanation: '⑤「購入する」のボタンをタッチします。', image: '/assets/img/point/gmoney/sm_step5.png' },
      { explanation: '⑥ご利用いただく電話機（チャージしたい電話機）の「電話番号」を入力します。間違いがなければ「OK」ボタンをタッチします。', image: '/assets/img/point/gmoney/sm_step6.png' },
      { explanation: '⑦確認のため もう一度同じ「電話番号」を入力します。間違いがなければ「OK」ボタンをタッチします。', image: '/assets/img/point/gmoney/sm_step7.png' },
      { explanation: '⑧購入したいポイントのボタンをタッチします。（例では1,500ポイントを選択しています ）', image: '/assets/img/point/gmoney/sm_step8.png' },
      { explanation: '⑨「ご購入内容」を確認し 間違いがなければ「OK」ボタンをタッチします。', image: '/assets/img/point/gmoney/sm_step9.png' },
      { explanation: '⑩申込券が発券されますので、レジにお持ちになり、お支払いをお済ませください。', image: '/assets/img/point/gmoney/sm_step10.png' },
      { explanation: '⑪お支払い完了後、下記用紙を受け取ってください。', image: '/assets/img/point/gmoney/sm_step11.jpg' },
      { explanation: '⑫本ページ下部より、ご購入頂いた金額を選択し、用紙に記載されているプリペイド番号をご入力ください。', image: '' }
    ]
  }
]

const NETRIDECASH_STORE_EXPLANATION = [
  {
    value: 'seven',
    title: 'セブンイレブンでNetRideCash（ネットライドキャッシュ）を購入',
    steps: [
      { explanation: '①マルチコピー機を探してください。', image: '/assets/img/point/netridecash/seven/step1.jpg' },
      { explanation: '②プリペイドを押してください。', image: '/assets/img/point/netridecash/seven/step2.jpg' },
      { explanation: '③ネットライドキャッシュを押してください。', image: '/assets/img/point/netridecash/seven/step3.jpg' },
      { explanation: '④「OK」を押してください。', image: '/assets/img/point/netridecash/seven/step4.jpg' },
      { explanation: '⑤「同意する」を押してください。', image: '/assets/img/point/netridecash/seven/step5.jpg' },
      { explanation: '⑥お買い求めになりたい金額（2000円～50000円）を選択してください。', image: '/assets/img/point/netridecash/seven/step6.jpg' },
      { explanation: '⑦金額を確認し、「OK」を押してください。', image: '/assets/img/point/netridecash/seven/step7.jpg' },
      { explanation: '⑧コピー機から払込票が出てきますので、30分以内にレジまでお持ちください。代金と引き換えにプリペイド番号が印字されたチケットをお受け取りください。', image: '/assets/img/point/netridecash/seven/step8.png' },
      { explanation: '⑨本ページ下部より、ご購入頂いた金額を選択し、用紙に記載されているプリペイド番号をご入力ください。', image: '' }
    ]
  },
  {
    value: 'lawson',
    title: 'ローソンでNetRideCash（ネットライドキャッシュ）を購入',
    steps: [
      { explanation: '①「Loppi」という機械を探してください。', image: '/assets/img/point/netridecash/lawson/step1.jpg' },
      { explanation: '②「各種サービスメニュー」を押してください。', image: '/assets/img/point/netridecash/lawson/step2.jpg' },
      { explanation: '③「携帯・国際プリペイド／ネット用マネー／QUO／各種申込」を押してください。', image: '/assets/img/point/netridecash/lawson/step3.jpg' },
      { explanation: '④「ネット用マネー」を押してください。', image: '/assets/img/point/netridecash/lawson/step4.jpg' },
      { explanation: '⑤「NetRideCash」を押してください。', image: '/assets/img/point/netridecash/lawson/step5.jpg' },
      { explanation: '⑥「OK」を押してください。', image: '/assets/img/point/netridecash/lawson/step6.jpg' },
      { explanation: '⑦お買い求めになりたい金額（2000円～50000円）を選択してください。', image: '/assets/img/point/netridecash/lawson/step7.jpg' },
      { explanation: '⑧金額を確認し、「OK」を押してください。', image: '/assets/img/point/netridecash/lawson/step8.jpg' },
      { explanation: '⑨最終確認をして「OK」を押してください。', image: '/assets/img/point/netridecash/lawson/step9.jpg' },
      { explanation: '⑩Loppiから申込券が出てきますのでレジに持参してお会計をし、プリペイド番号が印字されたチケットをお受け取りください。', image: '/assets/img/point/netridecash/lawson/step10.jpg' },
      { explanation: '⑪本ページ下部より、ご購入頂いた金額を選択し、用紙に記載されているプリペイド番号をご入力ください。', image: '' }
    ]
  },
  {
    value: 'familymart',
    title: 'ファミリーマートでNetRideCash（ネットライドキャッシュ）を購入',
    steps: [
      { explanation: '①マルチコピー機を探してください。', image: '/assets/img/point/netridecash/familymart/step1.jpg' },
      { explanation: '②「プリペイドの購入」を押してください。', image: '/assets/img/point/netridecash/familymart/step2.jpg' },
      { explanation: '③「オンラインマネーを購入する」を押してください。', image: '/assets/img/point/netridecash/familymart/step3.jpg' },
      { explanation: '④「NetRideCash」を押してください。', image: '/assets/img/point/netridecash/familymart/step4.jpg' },
      { explanation: '⑤「OK」を押してください。', image: '/assets/img/point/netridecash/familymart/step5.jpg' },
      { explanation: '⑥お買い求めになりたい金額（2000円～50000円）を選択してください。', image: '/assets/img/point/netridecash/familymart/step6.png' },
      { explanation: '⑦金額を確認し、「発行する」を押してください。', image: '/assets/img/point/netridecash/familymart/step7.jpg' },
      { explanation: '⑧マルチコピー機から印刷される「Mコピーサービス申込券」を30分以内にレジに持参し、代金と引き換えにプリペイド番号が印字された用紙をお受け取りください。', image: '' },
      { explanation: '⑨本ページ下部より、ご購入頂いた金額を選択し、用紙に記載されているプリペイド番号をご入力ください。', image: '' }
    ]
  }
]

const PRODUCTS = [
  {
    value: 'bank',
    label: '銀行振込'
  },
  {
    value: 'credit_wc',
    label: 'クレジットカード①決済'
  },
  {
    value: 'credit_telecom',
    label: 'クレジットカード②決済'
  },
  {
    value: 'credit_tc',
    label: 'クレジットカード③決済'
  },
  {
    value: 'bitcash',
    label: 'BitCash決済'
  },
  {
    value: 'netridecash',
    label: 'NetRideCash決済'
  },
  {
    value: 'securitymoney',
    label: 'SecurityMoney決済'
  },
  {
    value: 'gmoney',
    label: 'GMoney決済'
  }
]

export {
  GENDERS,
  GENDERS_SELECT,
  BIRTH_YEAR_SUB_START,
  BIRTH_YEAR_SUB_END,
  BLOOD_TYPE,
  BLOOD_TYPE_SELECT,
  GENRE_WORRY,
  GENRE_GENRE,
  HOROSCOPES,
  PAGE_FIXED_IDS,
  BITCASH_STORE_EXPLANATION,
  SECURITMONEY_FORM_EXPLANATION,
  GMONEY_FORM_EXPLANATION,
  NETRIDECASH_STORE_EXPLANATION,
  PRODUCTS
}
